<template>
  <article class="sa-kpi">
    <div class="sa-kpi__top">
      <span class="sa-kpi__label">{{ label }}</span>
      <span v-if="icon" class="sa-kpi__icon" aria-hidden="true">
        <fa :icon="icon" />
      </span>
    </div>
    <strong class="sa-kpi__value">{{ value }}</strong>
    <div v-if="hint || $slots.hint" class="sa-kpi__hint">
      <slot name="hint">{{ hint }}</slot>
    </div>
    <div v-if="trendLabel" class="sa-kpi__trend" aria-hidden="true">
      {{ trendLabel }}
    </div>
  </article>
</template>

<script>
export default {
  name: 'DashboardKpiCard',
  props: {
    label: { type: String, required: true },
    value: { type: String, required: true },
    hint: { type: String, default: '' },
    icon: { type: [String, Array, Object], default: null },
    /** Reservado para delta futuro — não inventar percentual */
    trendLabel: { type: String, default: '' },
  },
};
</script>

<style scoped>
.sa-kpi {
  background: var(--dashboard-card, #fff);
  border: 1px solid var(--dashboard-border, #e8eaf0);
  border-radius: 14px;
  padding: 1.15rem 1.2rem 1.2rem;
  min-width: 0;
}

.sa-kpi__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
}

.sa-kpi__label {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--dashboard-muted, #697386);
  line-height: 1.3;
}

.sa-kpi__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 8px;
  background: #f3f1fb;
  color: var(--dashboard-primary, #250891);
  font-size: 0.8rem;
  flex-shrink: 0;
}

.sa-kpi__value {
  display: block;
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.15;
  color: var(--dashboard-text, #191c24);
  letter-spacing: -0.02em;
  word-break: break-word;
}

.sa-kpi__hint {
  margin-top: 0.55rem;
  font-size: 0.8125rem;
  line-height: 1.4;
  color: var(--dashboard-muted, #697386);
}

.sa-kpi__trend {
  margin-top: 0.4rem;
  font-size: 0.75rem;
  color: var(--dashboard-muted, #697386);
}

@media (max-width: 480px) {
  .sa-kpi__value {
    font-size: 1.5rem;
  }
}
</style>
